import React from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import { BlogPost } from '@app/objects/Education';

export interface PostType {
	image: string;
	title: string;
	description: string;
	tags: Array<{ key: string, value: number, label: string }>;
	isYoutube?: boolean;
	link?: string;
}

interface Props {
	item: BlogPost;
	lazy?: boolean;
	onSelectTag?: (tag: { key: string, value: number, label: string }) => void;
	onTopic?: any;
	topicActive?: null | string;
}

const Post: React.FC<Props> = ({
	item,
	lazy,
	onTopic,
	topicActive,
}) => {
	const { pathname } = useLocation();
	const params = useParams<{category: string}>();
	const img = lazy
		? (
			<ImageLazy
				alt={item.title}
				src={item.avatar}
			/>)
		: (
			<img
				alt={item.title}
				src={item.avatar}
			/>
		);

	return <div className="post">
		<div className="post-image__wrapper">
			<div className="post-image">
				{item.urlPath
					? (
						<NavLink to={params.category
							? `${pathname}/${item.urlPath}`
							: `${pathname}/${item.category.urlPath}/${item.urlPath}`}
						>
							{img}
						</NavLink>
					)
					: img
				}
			</div>
			<div className="h3">
				{item.urlPath
					? (
						<NavLink to={params.category
							? `${pathname}/${item.urlPath}`
							: `${pathname}/${item.category.urlPath}/${item.urlPath}`}
						>
							{item.title}
						</NavLink>
					)
					: item.title
				}
			</div>
			{item.description && <div className="h4">
				{item.description}
			</div>}
			{item.topics.length ? <div className="post-tags">
				{item.topics.map((topic) => <button
					type="button"
					key={topic.id}
					className={`inline-select-item inline-select-item_sm ${topicActive === topic.topic.name && 'active'}`}
					onClick={() => {
						onTopic(topic.topic);
					}}
				>
					{topic.topic.name}
				</button>)}
			</div> : null}
		</div>
	</div>;
};

export default Post;
